import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import { Culture, DEFAULT_USER_LANGUAGE, parseCulture } from '@camelot/utils';

import { ContactScopeInterceptor } from './contact-scope.interceptor';
import { CamUsersService } from './services/users.service';

export const provideUser = (): Provider => [
  {
    provide: DEFAULT_USER_LANGUAGE,
    deps: [CamUsersService],
    useFactory: (usersService: CamUsersService) =>
      parseCulture(usersService.currentUser.get()?.culture, Culture.FR_BE),
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ContactScopeInterceptor,
    multi: true,
  },
];
